<div class="ups-dialog">
        <!-- [MV3-3909] clear-header class removed -->
    <div class="dialog-header">
        <h2 mat-dialog-title [innerHtml]="'paperlessCommercialInvoice.dialog.terms.title' | translate"></h2>
        <button type="button"
                mat-raised-button class="icon-button close-button"
                [mat-dialog-close]="false"
                tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <div class="dialog-message">{{ 'paperlessCommercialInvoice.dialog.terms.message' | translate }}</div>
        <div class="terms-title">{{ 'paperlessCommercialInvoice.dialog.terms.termsTitle' | translate }}</div>
        <div class="terms-message">
            <div class="term-message-content" id="invoice-terms">
                {{ 'paperlessCommercialInvoice.agreement.part1' | translate }}
                <a href="#" (click)="openTermsAndConditionsDialog($event)">
                    {{ 'sidebar.footer.links.termsConditions' | translate }}</a>
                {{ 'paperlessCommercialInvoice.agreement.part2' | translate }}
                <a href="#" (click)="openTermsOfUseDialog($event)">
                    {{ 'sidebar.footer.links.termsOfUse' | translate }}</a>
                {{ 'paperlessCommercialInvoice.agreement.part3' | translate }}
            </div>
        </div>
        <div class="terms-agreement">
            <mat-checkbox #termsAgreement>
                {{ 'paperlessCommercialInvoice.dialog.terms.termsAgreement' | translate }}
            </mat-checkbox>
        </div>

    </mat-dialog-content>
    <div class="mat-mdc-dialog-actions">
        <a href="#" class="cancel" (click)="closeDialog($event, false)">
            {{ 'paperlessCommercialInvoice.dialog.terms.cancel' | translate }}
        </a>
        <a href="#" (click)="printTerms($event)">
            {{ 'paperlessCommercialInvoice.dialog.terms.print' | translate }}
        </a>
        <button mat-raised-button
                type="button"
                [mat-dialog-close]="true"
                class="dense"
                [disabled]="!termsAgreement.checked">
            {{ 'paperlessCommercialInvoice.dialog.terms.accept' | translate }}
        </button>
    </div>
</div>
